import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import CustomStore from 'devextreme/data/custom_store';
import DevExpress from 'devextreme/bundles/dx.all';
import notify from 'devextreme/ui/notify';
import { LanguageService } from '../../../../shared/services/language.service';
import { UserService } from '../../../../shared/services/user.service';
import { ProductionStatusService } from '../../_api/services/production-status-service';

let self: CustomReport1Component = null;

@Component({
  selector: 'app-custom-report1',
  templateUrl: './custom-report1.component.html',
  styleUrls: ['./custom-report1.component.css']
})
export class CustomReport1Component implements OnInit {

  private _showPublicly = false;
  @Input() set showPublicly(v: boolean) {
    this._showPublicly = v;
  }
  get showPublicly() {
    return this._showPublicly;
  }
  @Output() refreshCallbackChanged = new EventEmitter<any>();
  @Input() showTitle: boolean;

  private _reportReportElementId: number = null; 
  @Input() set reportReportElementId(n: number) {
    this._reportReportElementId = n;
    if (this.productionDataGrid != null) {
      this.selectedProductionData = null;
      this.productionDataGrid.refresh();
    }
    if (this.rawDataGrid != null) {
      this.selectedProductionData = null;
      this.rawDataGrid.refresh();
    }
  }
  get reportReportElementId() {
    return this._reportReportElementId;
  }

  reportReportElement = null;

  selectedProductionData = null;

  rawDataGrid: DevExpress.ui.dxDataGrid;
  rawDataGridWidth: number;
  rawDataGridHeight: number;
  rawDataGridDataSource: any;
  rawDataGridDataSourceData: any;

  productionDataGrid: DevExpress.ui.dxDataGrid;
  productionDataGridWidth: number;
  productionDataGridHeight: number;
  productionDataGridDataSource: any;
  productionDataGridColumns: any;
  productionDataGridSummaryTotalItems: any;


  inspect(data) {
    
  }

  constructor(public ls: LanguageService, public us: UserService, public ds: ProductionStatusService) {
    self = this;
    this._reportReportElementId = null;
    this.showTitle = false;
    this.reportReportElement = null;
    this.rawDataGrid = null;
    this.rawDataGridWidth = 200;
    this.rawDataGridHeight = 200;

    this.productionDataGrid = null;
    this.productionDataGridWidth = 700;
    this.productionDataGridHeight = 500; 
    this.productionDataGridColumns = [];
    this.productionDataGridSummaryTotalItems = null;

    this.rawDataGridDataSource = {
      store: new CustomStore({
        key: "ProductionRawDataId",
        loadMode: "raw",
        load: () => {
          self.rawDataGridDataSourceData = null;
          let p: any = new Promise(function (resolve, reject) {
            let id = 0;
            if (self.selectedProductionData != null) {
              id = self.selectedProductionData.clickedProductionDataId;
            }
            self.ds.getProductionRawData(id).toPromise().then((data) => {
              self.rawDataGridDataSourceData = data;
              resolve(data.Data);
            }).catch((reason) => {
              reject("an error occurred:" + reason);
            });
          });

          return p;
        },
      })
    };

    this.productionDataGridDataSource = {
      store: new CustomStore({
        key: "Date",
        loadMode: "raw",
        load: () => {
          let theReport = null;
          let p: any = new Promise(function (resolve, reject) {
            self.ds.getCustomReport1(self._reportReportElementId, self.showPublicly).toPromise().then((data) => {
              if (data.ReportReportElement !== null) {
                theReport = data.ReportReportElement.Report;
                const cols = [], totalItems = [];
                let colIx = 0, latestLagTimeStamp = new Date(2000, 1, 1), latestLagDateFormatted = "";//AKA lagDays
                cols.push({ dataField: "Date", caption: "", colIx: colIx++, fixed: true, cellTemplate: "theCellTemplate0" });
                totalItems.push({ name: "Date", summaryType: "custom", showInColumn: "Date" });
                const noOfSecsIaDay = 1.0 * data.ReportReportElement.NumberOfSecondsInADay;
                for (let i = 0; i < data.Columns.length; i++) {
                  const name = `Value_${colIx}`;
                  let lag = null;
                  if (data.Columns[i].LatestLag != null) {
                    const d = new Date(data.Columns[i].LatestLag.Timestamp);
                    if (latestLagTimeStamp < d) {
                      latestLagTimeStamp = d;
                      latestLagDateFormatted = data.Columns[i].LatestLag.Date_formatted;//could also use Date_formattedShort
                    }
                    lag = (data.Columns[i].LatestLag.LagInSeconds / noOfSecsIaDay).toFixed(1);
                  }
                  cols[0].latestLagDateFormatted = latestLagDateFormatted;
                  cols.push({
                    theValueIndex: i, dataField: `Values[${i}]`, lag: lag, name: name, caption: data.Columns[i].Name, colIx: colIx++, cellTemplate: "theCellTemplate", productionLevel2: data.Columns[i].ProductionLevel2
                  });
                  totalItems.push({ name: name, summaryType: "custom", showInColumn: name });
                }
                self.reportReportElement = data.ReportReportElement;
                self.productionDataGridColumns = cols;
                self.productionDataGridSummaryTotalItems = totalItems;
                resolve(data.Rows);
              }
              else {
                self.reportReportElementId = null;
                self.reportReportElement = null;
                self.productionDataGridColumns = [];
                self.productionDataGridSummaryTotalItems = [];
                resolve([]);
                notify(self.ls.LNG('Label.AccessDenied'), "error", 10000);
              }
            }).catch((reason) => {
              theReport = null;
              reject("an error occurred:" + reason);
            }).finally(() => {
              if (self._showPublicly) {
                self.refreshCallbackChanged.emit({
                  sleepTimeInMilliSeconds: theReport !== null ? theReport.RefreshIntervalInMinutes * 60000 : 15 * 60000,//if the data retrieval failed wait 15 minutes before trying again
                  refreshFunction: self.refresh
                });
              }
            });
          });

          return p;
        },
      })
    };
  }

  refresh() {
    self.productionDataGrid.refresh();
    self.rawDataGrid.refresh();
  }

  productionDataGridSummary(options) {
    if (options.summaryProcess !== 'start')
      return;

    const cols = options.component.option('columns');
    let s = null;
    switch (options.name) {
      case "Date":
        options.totalValue = `${self.ls.LNG('Label.Lag')} ${cols[0].latestLagDateFormatted} `;
        break;
      default:
        s = options.name.split("_");
        if (s.length === 2) {
          options.totalValue = cols[s[1]].lag;
        }
        break;
    }
  }

  setGridDimensions(): void {
    const height = window.innerHeight - 230;
    const width1 = window.innerWidth * 0.4;
    const width2 = (window.innerWidth - width1);

    this.productionDataGridHeight = this.rawDataGridHeight = height;
    this.rawDataGridWidth = width1 - 15;
    this.productionDataGridWidth = width2 - 15 - 15;
  }


  ngOnInit() {
    this.setGridDimensions();
  }

  rawDataGridItialized(e): void {
    this.rawDataGrid = e.component;
  }

  calculateRawDataGridSummary(options):void {
    
    if (options.name === "OrderNumber") {
      let tot = 0;
      switch (options.summaryProcess) {
        case "start":
          options.on = {};
          options.totalValue = 0;
          break;
        case "calculate":
          //count distinct order numbers
          if (typeof (options.on[options.value]) === "undefined") {
            options.on[options.value] = 1;
          }
          break;
        case "finalize":
          for (let o in options.on) {
            tot++;
          }
          options.totalValue = tot;
          break;
      }
    }


    if (options.name === "OrderLineNumber") {
      let tot = 0;
      switch (options.summaryProcess) {
        case "start":
          options.oln = {};
          options.totalValue = 0;
          break;
        case "calculate":
          //count distinct order line numbers
          if (typeof (options.oln[options.value]) === "undefined") {
            options.oln[options.value] = 1;
          }
          break;
        case "finalize":
          for (let ol in options.oln) {
            tot++;
          }
          options.totalValue = tot;
          break;
      }
    }


    if (options.name === "NumberProducts") {
      switch (options.summaryProcess) {
        case "start":
          options.totalValue = 0;
          break;
        case "calculate":
          options.totalValue += options.value;
          break;
      }
    }

    
    if (options.name === "ProductionTime_inSeconds") {
      switch (options.summaryProcess) {
        case "start":
          options.totalValue = 0;
          break;
        case "calculate":
          options.totalValue += options.value;
          break;
      }
    }
  }



  productionDataGridCellClick(e): void {
    const data = e.data.Values[e.column.theValueIndex];
    if (data === null || !(data.NumberToDo > 0))
      return;

    //document.querySelectorAll('.dx-datagrid-table .selectedCell').forEach((e) => {
    //  e.classList.remove('selectedCell');
    //})

    let orderNoHeaderText = "";
    const clickedProductionDataId = data.ProductionDataId;
    if (self.selectedProductionData === null || self.selectedProductionData.clickedProductionDataId !== clickedProductionDataId) {
      e.cellElement.classList.add("selectedCell");
      orderNoHeaderText = e.data.DateFormatted;
      self.selectedProductionData = e.data;
      self.selectedProductionData.factory = e.column.productionLevel2.Name;
      self.selectedProductionData.rowIndex = e.rowIndex;
      self.selectedProductionData.clickedProductionDataId = clickedProductionDataId;
    }
    else {
      self.selectedProductionData = null;
    }
    self.rawDataGrid.columnOption(0, "caption", orderNoHeaderText);
    self.productionDataGrid.refresh();
    self.rawDataGrid.refresh();
  }

  productionDataGridCellPrepared(e): void {
    if (e.rowType === "data") {
      if (e.columnIndex === 0) {
        //HACK hardcoded that the date is the first column
        let theText = e.data.DateFormatted;
        if (self.selectedProductionData !== null && self.selectedProductionData.rowIndex === e.rowIndex) {
          theText += ` - ${self.selectedProductionData.factory}`;
        }
        e.cellElement.innerText = theText;
        const now = new Date(), m = now.getMonth() + 1, d = now.getDate();
        const today = `${now.getFullYear()}-${m < 10 ? "0" : ""}${m}-${d < 10 ? "0" : ""}${d}`;
        if (e.data.DateFormatted == today) {
          e.cellElement.style.fontWeight = "bold";
        }

      }
      else if (e.value.NumberToDo > 0 && e.columnIndex > 0 && e.value != null) {
        e.cellElement.classList.add("clickableCell");
        if (self.selectedProductionData !== null && self.selectedProductionData.clickedProductionDataId === e.value.ProductionDataId) {
          e.cellElement.classList.add("selectedCell");
        }
      }
    }
    else if (e.rowType === "header" && e.columnIndex === 0) {
      e.cellElement.style.color = "black";
    }
  }

  productionDataGridRowPrepared(e): void {
    //if (e.rowType === "totalFooter") {
    //  if (e.summaryCells.length == e.columns.length) {
    //    for (let i = 1; i < e.columns.length; i++) {
    //      if (e.columns[i].lag > 0) {
    //        e.summaryCells[i][0].value = e.columns[i].lag;
    //      }
    //    }
    //  }
    //  else {
    //    throw "The columns are mismatched! Lag cannot be shown!!";
    //  }
    //}
  }

  productionDataGridItialized(e): void {
    this.productionDataGrid = e.component;
  }


  rawDataGridOrderNumberText(cellInfo: any) {
    if (cellInfo.value > 0) {
      let filtered = "";
      if (cellInfo.value < self.rawDataGridDataSourceData.OrderNumber.Total) {
        filtered = ` (${cellInfo.value})`;
      }
      return `${self.rawDataGridDataSourceData.OrderNumber.NumberDone}/${self.rawDataGridDataSourceData.OrderNumber.Total}${filtered}`;
    }
    else {
      return "0";
    }
  }

  rawDataGridOrderLineNumberText(cellInfo: any) {
    if (cellInfo.value > 0) {
      let filtered = "";
      if (cellInfo.value < self.rawDataGridDataSourceData.OrderLineNumber.Total) {
        filtered = ` (${cellInfo.value})`;
      }
      return `${self.rawDataGridDataSourceData.OrderLineNumber.NumberDone}/${self.rawDataGridDataSourceData.OrderLineNumber.Total}${filtered}`;
    }
    else {
      return "0";
    }
  }

  rawDataGridOrderProductsText(cellInfo: any) {
    if (cellInfo.value > 0) {
      let filtered = "";
      if (cellInfo.value < self.rawDataGridDataSourceData.NumberProducts.Total) {
        filtered = ` (${cellInfo.value})`;
      }
      return `${self.rawDataGridDataSourceData.NumberProducts.NumberDone}/${self.rawDataGridDataSourceData.NumberProducts.Total}${filtered}`;
    }
    else {
      return "0";
    }
  }

  rawDataGridProductionTime_inSecondsText(cellInfo: any) {
    if (cellInfo.value > 0) {
      let filtered = "";
      if (cellInfo.value < self.rawDataGridDataSourceData.ProductionTime_inSeconds.Total) {
        filtered = ` (${cellInfo.value})`;
      }
      return `${self.rawDataGridDataSourceData.ProductionTime_inSeconds.NumberDone}/${self.rawDataGridDataSourceData.ProductionTime_inSeconds.Total}${filtered}`;
    }
    else {
      return "0";
    }
  }


}
